<template>
  <b-card
    v-if="data"
    body-border-variant="primary"
    body-class="rounded fast-track-card"
  >
    <h2 class="text-center" style="color:Red;">
      {{ title }}
    </h2>
    <b-col cols="12">
      <b-row>
        <b-col cols="3">
          เข้าร่วม Fasttrack
        </b-col>
        <b-col cols="9">
          {{ data.fastTrackAllowance }}
        </b-col>
      </b-row>
      <div v-for="(company, index) in data.mouCompanies" :key="index">
        <b-row>
          <b-col cols="3">
            หน่วยงาน
          </b-col>
          <b-col cols="9">
            {{ company.companyName }}
            <FastTrackIcon :isMouCompany="true" />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            หมายเลขคำสั่งซื้อ
          </b-col>
          <b-col cols="9">
            {{ company.purchaseNo }}
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            ไฟล์แนบรายละเอียดคำสั่งซื้อ
          </b-col>
          <b-col cols="9">
            <ul class="list-unstyled mb-0">
              <li
                v-for="(attachFile, index) in company.attachFiles"
                :key="index"
              >
                <a
                  :href="attachFile.filePath"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="file-link"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-arrow-down-circle"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="8 12 12 16 16 12" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                  </svg>
                  {{ attachFile.fileName }}
                </a>
              </li>
            </ul>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-card>
</template>
<script>
import { BRow, BCol, BCard, BImg } from "bootstrap-vue";
import FastTrackIcon from "@/views/Complaint/components/FastTrack/FastTrackIcon.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    FastTrackIcon,
  },
  props: {
    title: {
      type: String,
      default: "Fasttrack",
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {},
  methods: {
    mouCompanyNames(mouCompanies) {
      return mouCompanies?.map((c) => c.companyName).join(", ");
    },
  },
};
</script>

<style>
.fast-track-card {
  border: 3px dashed #7367f0 !important;
  background-color: #eeedfd !important;
}

.file-list {
  padding-left: 1.2rem;
  margin-bottom: 0;
  list-style-type: disc; /* disc | circle | square */
}

.file-list li {
  margin-bottom: 4px;
}
</style>
